module.exports = __webpack_public_path__ + "static/img/human_icon_1.4df8172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/human_icon_1.png
// module id = TxzC
// module chunks = 16